export default __webpack_public_path__ + "static/convolo-design-4f97fc559bb7ea2716b295a81b4e8c97.png";